"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDrmSystems = exports.buildCodecs = exports.buildResolutions = exports.registerNative = exports.registerHls = exports.registerSmoothStreaming = exports.registerDash = exports.RESOLUTION_HEIGHT = exports.BaseSupportedFormats = void 0;
var types_1 = require("../types");
var BaseSupportedFormats = (function () {
    function BaseSupportedFormats() {
        this.offline = false;
        this.background = false;
        this.manifest = [];
        this.typeIndex = {};
    }
    BaseSupportedFormats.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.finishInitialization();
                return [2];
            });
        });
    };
    BaseSupportedFormats.prototype.finishInitialization = function () {
        var _this = this;
        this.typeIndex = {};
        this.manifest.forEach(function (manifest) {
            if (!manifest.name || manifest.name === types_1.MANIFEST_NAME.NATIVE) {
                _this.typeIndex[types_1.MANIFEST_NAME.NATIVE] = manifest;
            }
            else {
                _this.typeIndex[manifest.name] = manifest;
            }
            manifest.mimeTypes.forEach(function (mimeType) {
                _this.typeIndex[mimeType] = manifest;
            });
        });
    };
    BaseSupportedFormats.prototype.toJson = function () {
        return {
            manifest: this.manifest,
            offline: this.offline,
            background: this.background,
        };
    };
    BaseSupportedFormats.prototype.findManifest = function (type) {
        return this.typeIndex[type || types_1.MANIFEST_NAME.NATIVE];
    };
    BaseSupportedFormats.prototype.isSupported = function (check) {
        if (!check)
            return false;
        var manifest = this.findManifest(check.type);
        if (!manifest)
            return false;
        if (check.offline && !manifest.offline)
            return false;
        var drmSupported = this.isDrmSupported(manifest, check.drm, check.provider, check.offline);
        if (!drmSupported)
            return false;
        if (!this.isCodecSupported(manifest.video, check.video))
            return false;
        if (!this.isCodecSupported(manifest.audio, check.audio))
            return false;
        return true;
    };
    BaseSupportedFormats.prototype.isDrmSupported = function (manifest, keySystem, provider, offline) {
        if (!keySystem)
            return true;
        var drm = manifest.drm.find(function (d) { return d.name === keySystem || d.keySystems.indexOf(keySystem) >= 0; });
        if (!drm)
            return false;
        if (offline && !drm.offline)
            return false;
        if (provider && drm.providers.indexOf(provider) < 0)
            return false;
        return true;
    };
    BaseSupportedFormats.prototype.isCodecSupported = function (options, searched) {
        return !searched || options.indexOf(searched) >= 0;
    };
    return BaseSupportedFormats;
}());
exports.BaseSupportedFormats = BaseSupportedFormats;
exports.RESOLUTION_HEIGHT = {
    HD: 720,
    FULL_HD: 1080,
    TV_4K: 2160,
};
function registerDash(maxHeight, checkCodec, checkWidevine, checkPlayReady, offline) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        name: types_1.MANIFEST_NAME.DASH,
                        mimeTypes: [types_1.MIME_TYPE.DASH, types_1.MIME_TYPE.MPEG_DASH],
                        resolution: buildResolutions(maxHeight),
                        video: buildCodecs([
                            types_1.VIDEO_CODEC.H264,
                            types_1.VIDEO_CODEC.H265,
                            types_1.VIDEO_CODEC.AV1,
                            types_1.VIDEO_CODEC.VP8,
                            types_1.VIDEO_CODEC.VP9,
                        ], checkCodec),
                        audio: buildCodecs([
                            types_1.AUDIO_CODEC.AAC,
                            types_1.AUDIO_CODEC.AC3,
                            types_1.AUDIO_CODEC.EAC3,
                            types_1.AUDIO_CODEC.OPUS,
                            types_1.AUDIO_CODEC.VORBIS,
                            types_1.AUDIO_CODEC.FLAC,
                        ], checkCodec),
                        text: buildCodecs([
                            types_1.TEXT_CODEC.VTT,
                            types_1.TEXT_CODEC.TTML,
                            types_1.TEXT_CODEC.SRT,
                            types_1.TEXT_CODEC.CEA608,
                        ], checkCodec)
                    };
                    return [4, buildDrmSystems([checkWidevine, checkPlayReady])];
                case 1: return [2, (_a.drm = _b.sent(),
                        _a.offline = offline,
                        _a)];
            }
        });
    });
}
exports.registerDash = registerDash;
function registerSmoothStreaming(maxHeight, checkCodec, checkWidevine, checkPlayReady, offline) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        name: types_1.MANIFEST_NAME.MSS,
                        mimeTypes: [types_1.MIME_TYPE.SMOOTH_STREAM, types_1.MIME_TYPE.SMOOTH_STREAM_NONXML],
                        resolution: buildResolutions(maxHeight),
                        video: buildCodecs([types_1.VIDEO_CODEC.AV1, types_1.VIDEO_CODEC.H264, types_1.VIDEO_CODEC.H265], checkCodec),
                        audio: buildCodecs([types_1.AUDIO_CODEC.AAC, types_1.AUDIO_CODEC.OPUS], checkCodec),
                        text: buildCodecs([types_1.TEXT_CODEC.TTML, types_1.TEXT_CODEC.CEA608], checkCodec)
                    };
                    return [4, buildDrmSystems([checkPlayReady, checkWidevine])];
                case 1: return [2, (_a.drm = _b.sent(),
                        _a.offline = offline,
                        _a)];
            }
        });
    });
}
exports.registerSmoothStreaming = registerSmoothStreaming;
function registerHls(maxHeight, checkCodec, checkFairPlay, offline) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        name: types_1.MANIFEST_NAME.HLS,
                        mimeTypes: [types_1.MIME_TYPE.HLS, types_1.MIME_TYPE.M3U8],
                        resolution: buildResolutions(maxHeight),
                        video: buildCodecs([types_1.VIDEO_CODEC.H265, types_1.VIDEO_CODEC.H264], checkCodec),
                        audio: buildCodecs([types_1.AUDIO_CODEC.AC3, types_1.AUDIO_CODEC.EAC3, types_1.AUDIO_CODEC.AAC], checkCodec),
                        text: buildCodecs([types_1.TEXT_CODEC.VTT, types_1.TEXT_CODEC.CEA608], checkCodec)
                    };
                    return [4, buildDrmSystems([checkFairPlay])];
                case 1: return [2, (_a.drm = _b.sent(),
                        _a.offline = offline,
                        _a)];
            }
        });
    });
}
exports.registerHls = registerHls;
function registerNative(maxHeight, checkFormat, checkCodec, offline) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, {
                    name: types_1.MANIFEST_NAME.NATIVE,
                    mimeTypes: buildCodecs([types_1.MIME_TYPE.MP4_VIDEO, types_1.MIME_TYPE.MP3_AUDIO], checkFormat),
                    resolution: buildResolutions(maxHeight),
                    video: buildCodecs([
                        types_1.VIDEO_CODEC.H264,
                        types_1.VIDEO_CODEC.H265,
                        types_1.VIDEO_CODEC.AV1,
                        types_1.VIDEO_CODEC.VP8,
                        types_1.VIDEO_CODEC.VP9,
                    ], checkCodec),
                    audio: buildCodecs([
                        types_1.AUDIO_CODEC.AAC,
                        types_1.AUDIO_CODEC.AC3,
                        types_1.AUDIO_CODEC.EAC3,
                        types_1.AUDIO_CODEC.OPUS,
                        types_1.AUDIO_CODEC.VORBIS,
                        types_1.AUDIO_CODEC.FLAC,
                    ], checkCodec),
                    text: buildCodecs([
                        types_1.TEXT_CODEC.VTT,
                        types_1.TEXT_CODEC.TTML,
                        types_1.TEXT_CODEC.SRT,
                        types_1.TEXT_CODEC.CEA608,
                    ], checkCodec),
                    drm: [],
                    offline: offline,
                }];
        });
    });
}
exports.registerNative = registerNative;
function buildResolutions(maxHeight) {
    var resolutions = [types_1.RESOLUTION_NAME.SD];
    if (maxHeight >= exports.RESOLUTION_HEIGHT.HD)
        resolutions.push(types_1.RESOLUTION_NAME.HD);
    if (maxHeight >= exports.RESOLUTION_HEIGHT.FULL_HD)
        resolutions.push(types_1.RESOLUTION_NAME.FULL_HD);
    if (maxHeight >= exports.RESOLUTION_HEIGHT.TV_4K)
        resolutions.push(types_1.RESOLUTION_NAME.TV_4K);
    return resolutions;
}
exports.buildResolutions = buildResolutions;
function buildCodecs(codecs, check) {
    return codecs.filter(function (codec) { return check(codec); });
}
exports.buildCodecs = buildCodecs;
function buildDrmSystems(builders) {
    return __awaiter(this, void 0, void 0, function () {
        var resolved;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, Promise.all(builders.map(function (b) { return b(); }))];
                case 1:
                    resolved = _a.sent();
                    return [2, resolved.filter(function (d) { return !!d; })];
            }
        });
    });
}
exports.buildDrmSystems = buildDrmSystems;
//# sourceMappingURL=index.js.map